var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition-group',{attrs:{"name":"list"}},_vm._l((_vm.creatorLivestreamInteractions),function(creatorLivestreamInteraction){return _c('div',{key:creatorLivestreamInteraction.id},[_c('creator-livestream-interaction-item',{attrs:{"creatorLivestreamInteraction":creatorLivestreamInteraction}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }